var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPyTorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 101,
    viewBox: "0 0 273 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 272,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_60704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8093 42.4843L87.0511 44.2297C89.9281 47.0859 89.9281 51.6876 87.0511 54.4909C84.174 57.3471 79.5388 57.3471 76.715 54.4909C73.8379 51.6347 73.8379 47.033 76.715 44.2297L81.2703 39.7074L81.9097 39.0727V35.6611L75.0367 42.4843C71.2007 46.2925 71.2007 52.4281 75.0367 56.2363C78.8728 60.0446 85.0531 60.0446 88.8093 56.2363C92.6453 52.4016 92.6453 46.2925 88.8093 42.4843Z",
    fill: "#EE4C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6516 40.7919C86.6516 41.493 86.0791 42.0613 85.3729 42.0613C84.6667 42.0613 84.0942 41.493 84.0942 40.7919C84.0942 40.0908 84.6667 39.5225 85.3729 39.5225C86.0791 39.5225 86.6516 40.0908 86.6516 40.7919Z",
    fill: "#EE4C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.578 51.2115H103.621V58.7487H101.383V37.3008H106.817C112.492 37.3008 115.209 40.0776 115.209 43.9652C115.289 48.752 111.932 51.2115 106.578 51.2115ZM106.817 39.4429C106.578 39.4429 103.701 39.4429 103.701 39.4429V49.3074L106.738 49.2281C110.813 49.1487 113.051 47.5619 113.051 44.2297C113.051 41.109 110.813 39.4429 106.817 39.4429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.225 58.6696L123.947 62.0812C122.508 65.8895 120.99 67.0002 118.832 67.0002C117.633 67.0002 116.754 66.6829 115.795 66.2862L116.434 64.3027C117.154 64.6994 117.953 65.0167 118.832 65.0167C120.031 65.0167 120.91 64.382 122.108 61.3672L123.147 58.5903L116.994 43.0928H119.311L124.266 56.0515L129.141 43.0928H131.379L125.225 58.6696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.678 39.4437V58.8288H136.44V39.4437H128.848V37.3809H146.217V39.4437C146.19 39.4437 138.678 39.4437 138.678 39.4437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.531 59.2254C148.135 59.2254 144.938 55.9725 144.938 50.9741C144.938 45.9758 148.295 42.6436 152.77 42.6436C157.246 42.6436 160.363 45.8964 160.363 50.8948C160.283 55.8931 156.926 59.2254 152.531 59.2254ZM152.611 44.627C149.254 44.627 147.096 47.2452 147.096 50.9741C147.096 54.7824 149.334 57.4006 152.691 57.4006C156.047 57.4006 158.205 54.7824 158.205 51.0535C158.205 47.1659 155.967 44.627 152.611 44.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.717 58.8288H163.56V43.0932L165.717 42.6172V45.9494C166.756 43.9659 168.275 42.6172 170.353 42.6172C171.392 42.6172 172.351 42.9345 173.15 43.3312L172.59 45.3147C171.871 44.918 171.072 44.6007 170.193 44.6007C168.514 44.6007 166.996 45.8701 165.717 48.6469V58.8288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.568 59.2254C176.773 59.2254 173.816 55.8138 173.816 50.9741C173.816 46.0551 177.092 42.6436 181.568 42.6436C183.486 42.6436 185.164 43.1196 186.523 43.9923L185.963 45.8964C184.764 45.1031 183.246 44.627 181.568 44.627C178.131 44.627 176.053 47.1659 176.053 50.8948C176.053 54.7031 178.291 57.2419 181.648 57.2419C183.246 57.2419 184.844 56.7659 186.043 55.9725L186.523 57.9559C185.084 58.7493 183.406 59.2254 181.568 59.2254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.736 58.8284V48.6465C199.736 45.8697 198.617 44.6796 196.379 44.6796C194.541 44.6796 192.783 45.6317 191.504 46.9011V58.8284H189.346V35.7143L191.504 35.2383V45.1821C193.182 43.516 195.26 42.7226 197.018 42.7226C200.055 42.7226 201.973 44.706 201.973 48.1176V58.8548H199.736V58.8284Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_60704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 32,
    fill: "white",
    transform: "translate(72 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyTorch);
export default __webpack_public_path__ + "static/media/PyTorch.99eea84b04e632d43fff782429d81fe3.svg";
export { ForwardRef as ReactComponent };